var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('item-filters',{attrs:{"getParams":_vm.getParams,"disableds":_vm.disableds,"decorators":_vm.decorators}}),_c('sku-list',{ref:"SKU_LIST",attrs:{"filterSkuCallback":_vm.filterSkuCallback},on:{"update:options":_vm.skuChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }